/*global GridAndFormController, GridController, FormController*/
/** @this {GridAndFormController} */
var TrackedPostmailEmbeddable = function(options){    
    GridAndFormController.call(this,"iz_tracked_postmail", 
    {
        grid: {
            directory: "views/tracked",
            name: window.app.context.isV2?"trackedPostmailGrid_v2":"trackedPostmailGrid",
            canCreate: false,
            serverSideMode: true,
            joinFetch: [
                { otherTable: "ir_attachment", readOnly: true, type: "2one", name: "attach", thisField: "id", otherField: "res_id", joinSearch: {res_model: "iz.tracked.postmail"}},
            ]
        },
        form: {
            directory: "views/tracked",
            name: "trackedPostmailForm",
            joinFetch: [
                { otherTable: "iz_tracked_postmail_event", name: "events", type:"2many"},
                { otherTable: "ir_attachment", readOnly: true, type: "2one", name: "attach", thisField: "id", otherField: "res_id", joinSearch: {res_model: "iz.tracked.postmail"}}
            ],
            buttonsHTML: FormController.globalsOptions.buttonsHTML
                .replace('id="btCreate"', 'id="btCreate" data-show-if="false"')
                .replace('id="btDelete"', 'id="btDelete" data-show-if="false"'),
            
        },
    }) ;


    this.gridController.prepareDataOnEnter = function(data, callback){
        if(data){
            //if we receive some data, we update the grid search options with a new
            //search criteria
            //the this.options object will be filled from HTML markup
            this.searchOptions = {
                res_model: options.searchmodel
            } ;
            this.searchOptions.res_id = data.id ;
        }
        //call the normal function on the grid super class to continue with standard grid behavior
        GridController.prototype.prepareDataOnEnter.call(this, data, callback) ;
    } ;

    this.gridController.onAddEvent = 
    this.formController.onAddEvent = function(ev){
        var postMail = ev.data.data ;
        this.navigate("~tracked-postmail-event-create-popup", {mail_id: postMail.id });
    } ;

    this.gridController.onDownload = 
    this.formController.onDownload = function(ev){
        var postMail = ev.data.data ;
        this.view.longTask(function(done){
            this.api.readPdf.download(postMail.attach, postMail.subject+".pdf", function(err){
                if(err){ return done(err) ;}
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    } ;
} ;

TrackedPostmailEmbeddable.prototype = Object.create(GridAndFormController.prototype);
TrackedPostmailEmbeddable.prototype.constructor = TrackedPostmailEmbeddable;

module.exports = TrackedPostmailEmbeddable ;
